export const KNOWN_PET_TYPES = ['dogs', 'cats'];
